import * as constants from '../constants';
import * as logger from './../../logger';
const defaultState = {
    parties: [],
    details:{},
    singlePartyMonthlyBalances: {},
    singlePartyTripSparkLine: {},
    singlePartyPayments: [],
    suggestedTrips: [],
    partyViewTab: 0,
    singlePaymentDetails: {},
    companyDetails: {},
    collectionReminder: null,
    settings: {

    },
    paymentTabFilter: {
        selectedFilterDate: 'ALL_MONTHS',
        setSelectedFilterTransaction: "TRIPS_PAYMENTS"
    },
    tripsTabFilter: {
        selectedFilterStatus: 'ALL',
        selectedFilterDate: "ALL_MONTHS"
    },
    partyIncomeReport: {},
    partyIncomeExcel: {},
    singlePartyMonthlyBalancesReports: {},
    partyTransactHistory: {}
}

export default function partiesReducer(state = defaultState, action) {
    switch (action.type) {
        case constants.GET_PARTY_MONTHLY_BALANCES:
            return { ...state, ...{ singlePartyMonthlyBalances: action.payload } };
        case constants.GET_PARTY_TRIP_SPARKLINE:
            return { ...state, ...{ singlePartyTripSparkLine: action.payload } };
        case constants.GET_PARTY_PAYMENTS:
            if (action.payload.merge) {
                return { 
                    ...state,
                    singlePartyPayments:{
                        ...action.payload,
                        payments: [
                          ...state.singlePartyPayments.payments,
                          ...action.payload.payments
                        ]
                    }
                };
            }else{
                return { ...state, ...{ singlePartyPayments: action.payload } };
            }
        case constants.GET_PARTY_SUGGESTIONS_TRIPS:
            return { ...state, ...{ suggestedTrips: action.payload } };
        case constants.SINGLE_PARTY_PAYMENT:
            return { ...state, ...{ partyViewTab: action.payload } };
        case constants.GET_SINGLE_PARTY_PAYMENT:
            return { ...state, ...{ singlePaymentDetails: action.payload } };
        case constants.GET_PARTY_TRANSACT_HISTORY:
            return { ...state, ...{ partyTransactHistory: action.payload } };
        case constants.GET_PARTY_DETAILS:
            return { ...state, ...{details: action.payload } };
        case constants.GET_PARTY_COMPANY_DETAILS:
            return { ...state, ...{ companyDetails: action.payload } };
        case constants.GET_PARTY_SETTINGS:
            return { ...state, ...{ settings: action.payload } };
        case constants.UPDATE_PARTY_PAYMENT_TAB_FILTER:
            return { ...state, ...{ paymentTabFilter: action.payload } };
        case constants.UPDATE_PARTY_TRIPS_TAB_FILTER:
            return { ...state, ...{ tripsTabFilter: action.payload } };
        case constants.GET_COLLECTION_REMINDER:
            return { ...state, ...{ collectionReminder: action.payload } };
        case constants.UPDATE_COLLECTION_REMINDER:
            return { ...state, ...{ collectionReminder: action.payload } };
        case constants.GET_PARTY_INCOME_REPORT:
            return { ...state, ...{ partyIncomeReport: action.payload } };
        case constants.PARTY_INCOME_EXCEL:
            return { ...state, ...{ partyIncomeExcel: action.payload } };
        case constants.GET_PARTY_MONTHLY_BALANCES_FOR_REPORTS:
            return { ...state, ...{ singlePartyMonthlyBalancesReports: action.payload } }
        default:
            return state;
    }
}